import { render, staticRenderFns } from "./AccordionMoisture.vue?vue&type=template&id=be9c5bf4"
import script from "./AccordionMoisture.vue?vue&type=script&lang=js"
export * from "./AccordionMoisture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports